// export const BASE_URL = 'https://enc.pythonanywhere.com/';   
// export const BASE_URL = 'http://127.0.0.1:8000';
export const BASE_URL = 'https://enceptics2.pythonanywhere.com'

	


